import React from 'react';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
} from 'react-bootstrap';
import axios from 'components/Axios/Axios.js';
import DNS from 'components/DNS/dns.js';
import Select from 'react-select';
import TimePickerComponent from 'components/DateTime/TimePicker';
import DateArrayPickerComponent from 'components/DateTime/DateArrayPicker';
import NotificationAlert from 'react-notification-alert';
import makeAnimated from 'react-select/animated';
import CircularProgress from '@mui/material/CircularProgress';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';


const ModalEDITReservation = ({showModalValue, setShowModal, showTodayDate, showMaxdayDate, getReservations, getUserReservations, fillDictWithValue, start, end, getSalle, showReservedIds}) => {
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const [validated, setValidated] = useState(false);
  const [showError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const animatedComponents = makeAnimated();
  let dict = fillDictWithValue();
  const {t} = useTranslation();

  if (showModalValue == true) {
    dict = fillDictWithValue();
  }

  const notificationAlertRef = React.useRef(null);
  const notify = (place, txt, typeNot, iconNot) => {
    const type = typeNot;
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{txt}</p>
          </div>
        </div>
      ),
      type: type,
      icon: iconNot,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const requestOptionsAxiosHeaders = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };

  const cleanDataReservation = () => {
    setLoading(false);
    setError(false);
    setShowModal(false);
    setValidated(false);
    dict.setSalleSelected([]);
    dict.setTitle('');
    dict.setDebutDate([]);
    dict.setDebutTime('');
    dict.setEndTime('');
    dict.setNbUser('');
    dict.setNbExternalUser('');
    dict.setValueLinkableSalle([]);
    dict.setLinkableSalle([]);
    dict.setSelectedDisposition([]);
    dict.setAllDispositionDisplay([]);
    dict.setSelectedRoomService([]);
    dict.setAllServicesDisplay([]);
    dict.setUserMax(0);
    dict.setUserMaxAll(0);
    dict.setDescription('');
    dict.setSelectedLinkableSalle([]);
  };

  const editReservation = (e) => {
    e.preventDefault();
    let dTime = dict.showDebutTime;
    let eTime = dict.showEndTime;
    if (typeof(dict.showDebutTime) != typeof(new Date())) {
      dTime = new Date('June 04, 2022 ' + dict.showDebutTime);
    }
    if (typeof(dict.showEndTime) != typeof(new Date())) {
      eTime = new Date('June 04, 2022 ' + dict.showEndTime);
    }
    // if (dTime.getMinutes() - nowMinute < 0) nowHour += 1;
    if (eTime.getHours() - dTime.getHours() < 0) {
      notify('tc', t(translations.MEETING_MODAL_MESSAGE4), 'warning', 'nc-icon nc-simple-remove');
      return;
    } else if (eTime.getHours() - dTime.getHours() == 0) {
      if (eTime.getMinutes() - dTime.getMinutes() <= 0) {
        notify('tc', t(translations.MEETING_MODAL_MESSAGE4), 'warning', 'nc-icon nc-simple-remove');
        return;
      }
    }
    // COLLAB
    // if (now == myFormattedDate) {
    //   notify('tc', 'Vous devez réserver 24H à l\'avance.', 'warning', 'nc-icon nc-simple-remove');
    //   return;
    // } else if (myFormattedDate == tomorrow && dTime.getHours() - nowHour < 0) {
    //   notify('tc', 'Vous devez réserver 24H à l\'avance.', 'warning', 'nc-icon nc-simple-remove');
    //   return;
    // }

    const date = dict.showDebutDate.length > 0 &&
      Array.isArray(dict.showDebutDate[0]) &&
      dict.showDebutDate[0].length > 0 ?
        dict.showDebutDate[0][0] :
        dict.showDebutDate;

    const requestOptionsAxiosPatch = {
      pk: dict.showResPk,
      name: dict.showTitle,
      nbUserExpected: dict.showNbUser,
      nbUser: 0,
      externalUsers: dict.showExternalUser,
      debutDate: date,
      endDate: date,
      debutTime: dTime.getHours() + ':' + (dTime.getMinutes() >= 10 ? dTime.getMinutes() : '0' + dTime.getMinutes()),
      endTime: eTime.getHours() + ':' + (eTime.getMinutes() >= 10 ? eTime.getMinutes() : '0' + eTime.getMinutes()),
      isTaken: false,
      reservedSalle: [],
      registeredUsers: [],
    };
    let tmpId = [];
    let Roomservice = '';
    dict.showSalle.map((value, key) => {
      value.name == dict.showSalleSelected ? (tmpId = tmpId.concat(value.pk)) : null;
    });
    dict.showSelectedLinkableSalle.map((value, key) => {
      tmpId = tmpId.concat(value.value);
    });
    if (tmpId.length == 0) {
      delete requestOptionsAxiosPatch.reservedSalle;
    } else {
      requestOptionsAxiosPatch['reservedSalle'] = tmpId;
    }
    if (dict.showSelectedDisposition != null && dict.showSelectedDisposition.length != 0) {
      requestOptionsAxiosPatch['WantedDisposition'] =
        dict.showSelectedDisposition['label'];
    } else {
      requestOptionsAxiosPatch['WantedDisposition'] = 'None';
    }
    if (dict.showSelectedRoomService != null && dict.showSelectedRoomService.length != 0) {
      dict.showSelectedRoomService.map((value, key) => {
        Roomservice = value['label'].replace(' ', '_') + ' ' + Roomservice;
      });
      requestOptionsAxiosPatch['WantedService'] = Roomservice;
    } else {
      requestOptionsAxiosPatch['WantedService'] = 'None';
    }
    requestOptionsAxiosPatch['comment'] = dict.showDescription;
    setLoading(true);
    axios
        .patch(
            DNS +
          '/salle/deleteGetPatchReservation/' +
          currentBuilding['currentbuildingRedux'].pk +
          '/',
            JSON.stringify(requestOptionsAxiosPatch),
            requestOptionsAxiosHeaders,
        )
        .then((response) => {
          if (response.data.status == 'occupied') {
            notify('tc', t(translations.MEETING_MODAL_MESSAGE5), 'danger', 'nc-icon nc-simple-remove');
            cleanDataReservation();
          } else {
            notify('tc', t(translations.MEETING_MODAL_MESSAGE6), 'success', 'nc-icon nc-check-2');
            cleanDataReservation();
            getReservations(start, end);
            getUserReservations();
          }
        })
        .catch((err) => {
          cleanDataReservation();
          if (err.response.data.t && err.response.data.t?.non_field_errors) {
            notify('tc', err.response.data.t.non_field_errors[0], 'danger', 'nc-icon nc-simple-remove');
          } else {
            notify('tc', t(translations.MEETING_MODAL_MESSAGE3), 'danger', 'nc-icon nc-simple-remove');
          }
        });
  };

  const handleSalleCombinable = (e) => {
    dict.setSelectedDisposition([]);
    dict.setSelectedRoomService([]);
    dict.setValueLinkableSalle(e);
    dict.setSelectedLinkableSalle(e);
    let nbMax = 0;
    let tmp = [];
    dict.showSalle.map((value, key) => {
      e.map((elem, nb) => {
        value.name == elem.label ?
          ((tmp = tmp.concat(value.AllServices)),
          (nbMax = nbMax + value.nbUserMax)) :
          null;
      });
    });
    dict.setUserMaxAll(dict.showUserMax + nbMax);
    let listOfServices = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfServices = listOfServices.concat(value));
      });
    });
    if (listOfServices.length == 0) {
      listOfServices = listOfServices.concat('None');
      dict.setAllServicesDisplay(dict.showAllServices);
    } else {
      dict.showAllServices.map((elem, key) => {
        if (!listOfServices.includes(elem.label)) {
          listOfServices = listOfServices.concat(elem.label);
        }
      });
      tmp = [];
      listOfServices.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      dict.setAllServicesDisplay(tmp);
    }

    tmp = [];
    dict.showSalle.map((value, key) => {
      e.map((elem, nb) => {
        value.name == elem.label ?
          (tmp = tmp.concat(value.AllDispositions)) :
          null;
      });
    });
    let listOfDispositions = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfDispositions = listOfDispositions.concat(value));
      });
    });
    if (listOfDispositions.length == 0) {
      listOfDispositions = listOfDispositions.concat('None');
      dict.setAllDispositionDisplay(dict.showAllDisposition);
    } else {
      dict.showAllDisposition.map((elem, key) => {
        if (!listOfDispositions.includes(elem.label)) {
          listOfDispositions = listOfDispositions.concat(elem.label);
        }
      });
      tmp = [];
      listOfDispositions.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      dict.setAllDispositionDisplay(tmp);
    }
  };

  const dropdownLinkableSalle = (e) => {
    dict.setSelectedDisposition([]);
    dict.setSelectedRoomService([]);
    dict.setValueLinkableSalle(null);
    let tmp = [];
    let AllDispositionsTab = [];
    let AllServicesTab = [];
    dict.showSalle.map((value, key) => {
      value.name === e.value ?
        ((tmp = value.linkSalle),
        value.AllDispositions.split(' ').map((elem, key) => {
          AllDispositionsTab = AllDispositionsTab.concat({
            value: key,
            label: elem,
          });
        }),
        value.AllServices.split(' ').map((elem, key) => {
          AllServicesTab = AllServicesTab.concat({value: key, label: elem});
        }),
        dict.setUserMax(value.nbUserMax),
        dict.setUserMaxAll(value.nbUserMax)) :
        null;
    });
    dict.setAllDisposition(AllDispositionsTab);
    dict.setAllDispositionDisplay(AllDispositionsTab);
    dict.setAllServices(AllServicesTab);
    dict.setAllServicesDisplay(AllServicesTab);
    let concatTmp = [];
    tmp.map(
        (value, key) =>
          (concatTmp = concatTmp.concat({value: value.id, label: value.name})),
    );
    dict.setLinkableSalle(concatTmp);

    tmp = [];
  };

  const handleSubmit = (event) => {
    if (
      dict.showTitle == '' ||
      dict.showSalleSelected.length == 0 ||
      dict.showDebutDate == [] ||
      dict.showDebutDate == null ||
      dict.showDebutTime == '' ||
      dict.showDebutTime == null ||
      dict.showEndTime == '' ||
      dict.showEndTime == null ||
      (dict.showNbUser == '' && dict.showNbUser != 0)
    ) {
      setError(true);
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      setError(false);
    }
  };

  const changeToSpace = (toChange) => {
    let tmp = [];
    toChange.map((elem, key) => {
      elem = {'value': elem.value, 'label': elem.label.replace('_', ' ')};
      tmp = tmp.concat(elem);
    });
    return (tmp);
  };

  const checkNbUser = (value) => {
    if (value > dict.showUserMaxAll) {
      dict.setNbUser(dict.showUserMaxAll);
    } else {
      dict.setNbUser(value);
    }
  };

  const checkNbUserExternal = (value) => {
    if (parseInt(value) > parseInt(dict.showNbUser)) {
      dict.setNbExternalUser(dict.showNbUser);
    } else {
      dict.setNbExternalUser(value);
    }
  };

  const checkTimeDebut = () => {
    if (typeof(dict.showDebutTime) == typeof('string')) {
      return (new Date('June 04, 2022 ' + dict.showDebutTime));
    } else {
      return (dict.showDebutTime);
    }
  };

  const checkTimeEnd = () => {
    if (typeof(dict.showEndTime) == typeof('string')) {
      return (new Date('June 04, 2022 ' + dict.showEndTime));
    } else {
      return (dict.showEndTime);
    }
  };

  React.useEffect(() => {
    if (dict.showDebutDate != [] && dict.showDebutTime != '' && dict.showEndTime != '') {
      let dTime = dict.showDebutTime;
      let eTime = dict.showEndTime;
      if (typeof(dict.showDebutTime) != typeof(new Date())) {
        dTime = new Date('June 04, 2022 ' + dict.showDebutTime);
      }
      if (typeof(eTime) != typeof(new Date())) {
        eTime = new Date('June 04, 2022 ' + dict.showEndTime);
      }
      const debutTime = dTime.getHours() + ':' + (dTime.getMinutes() >= 10 ? dTime.getMinutes() : '0' + dTime.getMinutes());
      const endTime = eTime.getHours() + ':' + (eTime.getMinutes() >= 10 ? eTime.getMinutes() : '0' + eTime.getMinutes());
      getSalle(dict.showDebutDate, debutTime, endTime, [dict.showResPk]);
    }
  }, [dict.showDebutDate, dict.showDebutTime, dict.showEndTime]);

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        size="lg"
        className="modal modal-primary"
        show={showModalValue}
        onHide={() => {
          if (!loading) {
            setShowModal(false);
          }
        }}
        onSubmit={(e) => editReservation(e)}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon fa fa-edit"></i>
          </div>
        </Modal.Header>
        {!loading ?
          <div className="modal-body">
            <p className="text-center">
              {t(translations.MEETING_MODAL_TITLE2)}
            </p>
            <Form
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <Form>
                <Row>
                  <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                    <Form.Group controlId="formHorizontalReservation">
                      <Form.Label>{t(translations.TITLE) + ' :'}</Form.Label>
                      <Form.Control
                        required
                        type="Titre"
                        maxLength={50}
                        value={dict.showTitle}
                        placeholder={t(translations.TITLE)}
                        onChange={(e) =>
                          dict.setTitle(e.currentTarget.value)
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(translations.TITLE_ERROR)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                    <Form.Group controlId="formHorizontalReservation">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD2)}</Form.Label>
                      <Form.Control
                        required
                        as="select"
                        value={dict.showSalleSelected}
                        onChange={(e) => {
                          dict.setSalleSelected(e.currentTarget.value),
                          dropdownLinkableSalle(e.target);
                        }}
                      >
                        <option value={dict.showReserved[0].name}>
                          {dict.showReserved[0].name}
                        </option>
                        {dict.showSalle
                            .filter(
                                (elem) => elem.name != dict.showReserved[0].name,
                            )
                            .map((value, key) => (
                              <option value={value.name} key={key} >
                                {value.name}
                              </option>
                            ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {t(translations.MEETING_MODAL_FIELD2_ERROR)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <Form>
                <Row>
                  <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                    <Form.Group controlId="formHorizontalReservation">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD3)}</Form.Label>
                      <Select
                        isSearchable={true}
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        value={dict.showValueLinkableSalle}
                        options={dict.showLinkableSalle}
                        onChange={(e) => handleSalleCombinable(e)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formHorizontalReservation">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD4)}</Form.Label>
                      <Select
                        isClearable={false}
                        isSearchable={true}
                        components={animatedComponents}
                        value={dict.showSelectedDisposition}
                        options={dict.showAllDispositionDisplay}
                        onChange={(e) =>
                          dict.setSelectedDisposition(e == null ? [] : e)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formHorizontalReservation">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD5)}</Form.Label>
                      <Select
                        isClearable={false}
                        isSearchable={true}
                        isMulti
                        components={animatedComponents}
                        value={changeToSpace(dict.showSelectedRoomService)}
                        options={changeToSpace(dict.showAllServicesDisplay)}
                        onChange={(e) => dict.setSelectedRoomService(e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <Form>
                <Row>
                  <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                    <Form.Group controlId="formHorizontalDate">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD)}</Form.Label>
                      <DateArrayPickerComponent required showDate={dict.showDebutDate} setDate={dict.setDebutDate} min={showTodayDate} max={showMaxdayDate} validated={showError} />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formHorizontalHour">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD2)}</Form.Label>
                      <TimePickerComponent required showHour={checkTimeDebut()} setHour={dict.setDebutTime} validated={showError} />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formHorizontalHour">
                      <Form.Label>{t(translations.APPOINTMENT_COMMENT3) + ' :'}</Form.Label>
                      <TimePickerComponent required showHour={checkTimeEnd()} setHour={dict.setEndTime} validated={showError} />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <Form>
                <Row>
                  <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                    <Form.Group controlId="formHorizontalHour">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD6)}</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        placeholder={'max: ' + dict.showUserMaxAll}
                        min="0"
                        max={dict.showUserMaxAll}
                        value={dict.showNbUser}
                        onChange={(e) =>
                          checkNbUser(e.currentTarget.value)
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(translations.MEETING_MODAL_FIELD6_ERROR)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                    <Form.Group controlId="formHorizontalHour">
                      <Form.Label>{t(translations.MEETING_MODAL_FIELD6_EXTERNAL)}</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        placeholder={`max: ${dict.showNbUser === '' ? 0 : dict.showNbUser}`}
                        min="0"
                        max={dict.showNbUser}
                        value={dict.showExternalUser}
                        onChange={(e) =>
                          checkNbUserExternal(e.currentTarget.value)
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(translations.MEETING_MODAL_FIELD6_EXTERNAL_ERROR)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <Form>
                <Row>
                  <Col sm={12}>
                    <Form.Control
                      as="textarea"
                      maxLength={300}
                      rows={3}
                      placeholder="Description"
                      value={dict.showDescription}
                      onChange={(e) =>
                        dict.setDescription(e.currentTarget.value)
                      }
                    />
                  </Col>
                </Row>
                <br></br>
              </Form>
              <Form.Group as={Row}>
                <Button
                  className="btn-simple btn-round col-sm-6"
                  type="button"
                  variant="link"
                  onClick={() => setShowModal(false)}
                >
                  {t(translations.CLOSE)}
                </Button>
                <Button
                  className="btn-fill btn-round col-sm-6"
                  type="submit"
                >
                  {t(translations.EDIT)}{' '}
                </Button>
              </Form.Group>
            </Form>
          </div> :
          <div className="modal-body" style={{alignItems: 'center', justifyContent: 'center', width: '100%', display: 'flex'}}>
            <CircularProgress style={{color: '#F6B540'}}/>
          </div>
        }
      </Modal>
    </>
  );
};

export default ModalEDITReservation;
